var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[("" + _vm.cssPrefix)]},[_c('sw-content-toolbar-expand',{attrs:{"filter-block-grid":_vm.filterBlockGrid,"visible":_vm.expandVisible}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }